import React from "react";
import Layout from "../../Components/Dashboard/Layout/Layout";
import CreateProjectSection1 from "../../Components/Dashboard/CreateProject/CreateProjectSection1";

const CreateProject = () => {
  return (
    <>
      <Layout>
        <div
          className="dashboard__content hover-bgc-color"
          style={{ marginTop: "6%" }}
        >
          <CreateProjectSection1 />
        </div>
      </Layout>
    </>
  );
};

export default CreateProject;
